import React, { FC, useState } from 'react';
import { FCOType } from '../../../core/types/fcoTypes';

import styled from '@emotion/styled';
import { FlexGroup, FlexItem, Icon, IconType, Link, SelectPopover, Text } from '@lithos';

type RelatedFCOType = {
  name: string;
  description?: string;
};

interface RelatedFCOLink extends RelatedFCOType {
  type: FCOType;
  workspace: string;
}

interface RelatedFCOsProps {
  fcos: RelatedFCOType[];
  type: FCOType;
  workspace: string;
}

const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.colors.title};
  :hover {
    color: ${({ theme }) => theme.colors.title};
  }
`;

const typeMap: Record<FCOType, IconType> = {
  [FCOType.DATA_SOURCE]: 'Sources',
  [FCOType.ENTITY]: 'Entities',
  [FCOType.FEATURE_VIEW]: 'FeatureView',
  [FCOType.FEATURE_SERVICE]: 'FeatureService',
  [FCOType.TRANSFORMATION]: 'Transformations',
  [FCOType.DATASET]: 'Dataset',
  [FCOType.UNKNOWN]: 'AccountsAndAccess',
};

const RelatedFCOs: FC<RelatedFCOsProps> = ({ fcos, type, workspace }) => {
  const [isOpen, setIsOpen] = useState(false);

  const itemFcos = fcos.map((fco) => (
    <RelatedFCOLink name={fco.name} description={fco.description} type={type} workspace={workspace} />
  ));

  return (
    <SelectPopover
      trigger={
        <FlexGroup padding="0" css={{ width: 'auto', cursor: 'pointer', display: 'inline-flex' }} alignItems="center">
          <FlexItem grow="0" shrink="0">
            <FlexGroup alignItems="center" padding="0" gapSize="0">
              <Icon icon={typeMap[type]} size="s" type="mono" />
            </FlexGroup>
          </FlexItem>
          <FlexItem grow="0" shrink="0">
            <Text>{fcos.length}</Text>
          </FlexItem>
        </FlexGroup>
      }
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      groups={[{ items: itemFcos.map((fco) => ({ name: fco })) }]}
      label={''}
    />
  );
};

export const RelatedFCOLink: FC<RelatedFCOLink> = ({ name, type, workspace }) => {
  const linkToMap: Record<FCOType, string> = {
    [FCOType.DATA_SOURCE]: `/repo/${workspace}/data-sources/`,
    [FCOType.ENTITY]: `/repo/${workspace}/entities/`,
    [FCOType.FEATURE_VIEW]: `/repo/${workspace}/features/`,
    [FCOType.FEATURE_SERVICE]: `/repo/${workspace}/feature-services/`,
    [FCOType.TRANSFORMATION]: `/repo/${workspace}/transformations/`,
    [FCOType.DATASET]: `/repo/${workspace}/datasets/`,
    [FCOType.UNKNOWN]: `/repo/${workspace}/home/`,
  };
  return <Link url={`${linkToMap[type]}/${name}`} name={name} icon={typeMap[type]} />;
};

export default RelatedFCOs;
